import { InsuranceDetails } from 'Api/insurance';
import { MyInsuranceBaseError } from 'Components/MyInsuranceBaseError';
import { ProductName } from 'Constants/products.constants';
import {
  CancelFormValues,
  ProductInsuranceCancelRequest,
} from './cancelForm.types';
import { CancelAkaHouseContentsFormValues } from './products/akaHouseContents/cancelAkaHouseContentsForm.types';
import { mapToCancellationAkaHouseContents } from './products/akaHouseContents/mappers/mapToCancellationAkaHouseContents';
import { CancelAkaStudentFormValues } from './products/akaStudent/cancelAkaStudentForm.types';
import { mapToCancellationAkaStudent } from './products/akaStudent/mappers/mapToCancellationAkaStudent';
import { CancelAkaTravelFormValues } from './products/akaTravel/cancelAkaTravelForm.types';
import { mapToCancellationAkaTravel } from './products/akaTravel/mappers/mapToCancellationAkaTravel';
import { mapToCancellationElectricScooter } from './products/electricScooter/mappers/mapToCancellationElectricScooter';
import { CancelTravelFormValues } from './products/travel/cancelTravelForm.types';
import { mapToCancellationTravel } from './products/travel/mappers/mapToCancellationTravel';

export const mapToCancellationRequest = (
  insurance: InsuranceDetails,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  values: CancelFormValues,
): ProductInsuranceCancelRequest => {
  switch (insurance.insuranceProduct) {
    case ProductName.ELECTRIC_SCOOTER:
      return mapToCancellationElectricScooter();
    case ProductName.TRAVEL:
      return mapToCancellationTravel(values as CancelTravelFormValues);
    case ProductName.AKA_HOUSE_CONTENTS:
      return mapToCancellationAkaHouseContents(
        values as CancelAkaHouseContentsFormValues,
      );
    case ProductName.AKA_TRAVEL:
      return mapToCancellationAkaTravel(values as CancelAkaTravelFormValues);
    case ProductName.AKA_STUDENT:
      return mapToCancellationAkaStudent(values as CancelAkaStudentFormValues);
    default:
      throw new MyInsuranceBaseError('Invalid cancellation request');
  }
};
